import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  BillStatus,
  CANCELLED_RESTO_BILL_DETAILS,
  getAuthSession,
  SUCCESS,
} from "../../../constants/constant";
import { snpAxios } from "../../global/api";
import DialogBox from "../../global/DialogBox";
import DismissButton from "../../global/DismissButton";
import { Box } from "../../ui";

export const isCancelledRestoBill = (billStatus, billNo) =>
  Number(billStatus) === BillStatus.CANCEL_BILL && Boolean(String(billNo || "").trim());

const CancelledBillDialog = ({ billStatus, billNo }) => {
  const api = useSelector((state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL)?.BACKEND_BASE_URL;
  const shopHash = useSelector((state) => state.setActiveShopHashReducer.activeShopHash)?.id;
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState(null);
  const fetchedBill = useRef("");

  useEffect(() => {
    if (!isCancelledRestoBill(billStatus, billNo) || !api || !shopHash) return;
    const key = `${shopHash}:${billNo}`;
    if (fetchedBill.current === key) return;
    fetchedBill.current = key;
    let active = true;
    snpAxios.get(`${api}${CANCELLED_RESTO_BILL_DETAILS}`, {
      params: { token: getAuthSession().apiToken, shopHash, billNo },
    }).then((response) => {
      if (!active) return;
      setDetails(response.data.status === SUCCESS ? response.data.jcJson : { billNo });
      setOpen(true);
    }).catch(() => {
      if (!active) return;
      setDetails({ billNo });
      setOpen(true);
    });
    return () => { active = false; };
  }, [api, billNo, billStatus, shopHash]);

  return <DialogBox
    showDialog={open}
    title="Already cancelled"
    onClose={() => setOpen(false)}
    outsideClickedDismiss={false}
    mwidth="sm"
    mFullWidth
    dialogContent={<Box sx={{ display: "grid", gap: 1, overflowWrap: "anywhere" }}>
      <Box><strong>Bill:</strong> {details?.billNo || billNo}</Box>
      <Box><strong>Past rate:</strong> ₹{Number(details?.pastRate || 0).toFixed(2)}</Box>
      <Box><strong>Reason:</strong> {details?.reason || "Not available"}</Box>
      <Box><strong>Cancelled by:</strong> {details?.deletedBy || "Not available"}</Box>
    </Box>}
    dialogActions={<DismissButton variant="contained" onClick={() => setOpen(false)}>Close</DismissButton>}
  />;
};

export default CancelledBillDialog;
